import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: 'mainNav',
  components: {
    Multiselect
  },
  created() {
    this.$eventHub.$on('open-sideDrawer', () => {
      this.view.sideNav=true
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('open-sideDrawer');
  },
  props: [],
  data () {
    return {
      view: {
        sideNav: false
      },
      selectedDropdownOrg: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    org () {
      return this.$store.getters.activeOrg
    },
    availableOrgs () {
      return this.$store.getters.allOrgs
    },
    orgAccess () {
      return this.$store.getters.activeOrgAccess;
    }
  },
  watch:{
    $route () {
      // console.log('$route:', this.$route);
      // this.currentRoute = this.$route.matched[0]['path'];
      this.view.sideNav = false;
    },
    org () {
      if(this.org){
        this.selectedDropdownOrg = this.org.name
      }
    }
  },
  mounted () {
    console.log('mainNav mounted, org:', this.org);
    if(this.org){
      this.selectedDropdownOrg = this.org.name
    }

    console.log("availableOrgs:", this.availableOrgs)
  },
  methods: {
    toggleSideNav () {
      this.view.sideNav = !this.view.sideNav
    },
    orgDropdownChange () {
      console.log('org dropdown changed to:', this.selectedDropdownOrg)
   
      if(this.org && this.org.name === this.selectedDropdownOrg) return 

      if(this.selectedDropdownOrg === 'view-all') {
        this.$router.push('/')
        return
      }

      console.log('this.selectedDropdownOrg', this.selectedDropdownOrg);      

      this.$router.push({
        name: 'Organisation', 
        params: { org: this.selectedDropdownOrg.name } 
      })
    }
  }
}
